var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReloadIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0A78CD",
  d: "M13.649 2.35A7.97 7.97 0 0 0 7.995 0 7.99 7.99 0 0 0 0 8c0 4.42 3.572 8 7.995 8 3.732 0 6.844-2.55 7.735-6h-2.081c-.821 2.33-3.042 4-5.654 4a6.007 6.007 0 0 1-6.004-6c0-3.31 2.692-6 6.004-6 1.661 0 3.142.69 4.223 1.78L8.996 7H16V0z"
})));
export default SvgReloadIcon;